import api from '@/services/api.js';
import qs from 'qs';

export default {
    getAll(portfolioId){
        const query = qs.stringify({ _where: { 'portfolio_id': portfolioId } });
        return api.get(`/Usertoaccess-grouptoportfolios?${query}`);
    },
    add(contact) {
        return api.post('/contacts', contact);
    },
    update(contact){
        return api.put('/contacts/' + contact.id, contact);
    },
    delete(contactId){
        return api.delete('/contacts/' + contactId);
    },
    connect(contactCode, userId){
        return api.put('/contacts/connect/' + contactCode + "/" + userId);
    },
    getAllForUser(userId){
        return api.get('/contacts/user/' + userId);
    }
}